/**
 * card_number: "4111111111111111",
 * holder_name: "Juan Perez Ramirez",
 * expiration_year: "20",
 * expiration_month: "12",
 * cvv2: "110",
 */
export interface CreditCardInfo {
  card_number: number;
  holder_name: string;
  expiration_year: number;
  expiration_month: number;
  cvv2: number;
  address?: CreditCardAddress;
  nextPayments?: boolean;
  privacyPolicy?: boolean;
}

export interface CreditCardAddress {
  city?: string;
  line3?: string;
  postal_code?: string;
  line1?: string;
  line2?: string;
  state?: string;
  country_code?: string;
}

export interface CreateCardToken {
  id: string;
  card: CreditCard;
  response_time: number;
}
export interface CreditCard {
  card_number: string;
  holder_name: string;
  expiration_year: string;
  expiration_month: string;
  address: CreditCardAddress;
  creation_date: string;
  brand: string;
  type: string;
}

export interface CreateCardError {
  message: string;
  status: number;
  data: {
    http_code: number;
    error_code: number;
    category: string;
    description: string;
    request_id: string;
  };
}

export enum CARD_TYPE {
  CREDIT = 'credit',
  DEBIT = 'debit',
}

export type CardType = CARD_TYPE;
export interface CreditCardTypeResponse {
  bin: string;
  cardType: CardType;
  installments: any[];
  withInterest: boolean;
}
